// 🛡️ Configuração de Usuários via Environment Variables - MÁXIMA SEGURANÇA
// Credenciais são carregadas das variáveis de ambiente em tempo de execução
// NÃO expõe credenciais no código-fonte

import EnvConfig from './EnvConfig';
import SecurePasswordHash from '../auth/SecurePasswordHash';

// Gera credenciais iniciais do sistema
// SEMPRE carrega do .env, independente de variáveis de ambiente no React
export const INIT_USERS = [
  // 👥 ADMINISTRADORES
  {
    id:"admin",
    username:process.env.REACT_APP_SGV_ADMIN_USERNAME||"admin",
    password:process.env.REACT_APP_SGV_ADMIN_PASSWORD||"", // Mantido por compatibilidade
    passwordHash: process.env.REACT_APP_SGV_ADMIN_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_ADMIN_PASSWORD, process.env.REACT_APP_SGV_ADMIN_USERNAME||"admin").hash :
      "", // Hash seguro
    passwordSalt: process.env.REACT_APP_SGV_ADMIN_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_ADMIN_PASSWORD, process.env.REACT_APP_SGV_ADMIN_USERNAME||"admin").salt :
      "", // Salt seguro
    passwordVersion:"2.0", // Indica que usa hash v2.0
    role:"admin",
    name:"Administrador",
    vehicleId:null
  },
  {
    id:"clf",
    username:process.env.REACT_APP_SGV_CLF_USERNAME||"clf",
    password:process.env.REACT_APP_SGV_CLF_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_CLF_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_CLF_PASSWORD, "clf").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_CLF_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_CLF_PASSWORD, "clf").salt :
      "",
    passwordVersion:"2.0",
    role:"admin",
    name:"CLF",
    vehicleId:null
  },
  {
    id:"orec",
    username:process.env.REACT_APP_SGV_OREC_USERNAME||"orec",
    password:process.env.REACT_APP_SGV_OREC_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_OREC_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_OREC_PASSWORD, "orec").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_OREC_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_OREC_PASSWORD, "orec").salt :
      "",
    passwordVersion:"2.0",
    role:"admin",
    name:"OREC",
    vehicleId:null
  },
  // 👥 ADMINISTRADORES OCULTOS
  {
    id:"teixeira",
    username:process.env.REACT_APP_SGV_TEIXEIRA_USERNAME||"teixeira",
    password:process.env.REACT_APP_SGV_TEIXEIRA_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_TEIXEIRA_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_TEIXEIRA_PASSWORD, "teixeira").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_TEIXEIRA_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_TEIXEIRA_PASSWORD, "teixeira").salt :
      "",
    passwordVersion:"2.0",
    role:"admin",
    name:"Teixeira",
    vehicleId:null,
    hidden:true
  },
  {
    id:"caldas",
    username:process.env.REACT_APP_SGV_CALDAS_USERNAME||"caldas",
    password:process.env.REACT_APP_SGV_CALDAS_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_CALDAS_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_CALDAS_PASSWORD, "caldas").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_CALDAS_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_CALDAS_PASSWORD, "caldas").salt :
      "",
    passwordVersion:"2.0",
    role:"admin",
    name:"Caldas",
    vehicleId:null,
    hidden:true
  },
  // 👥 USUÁRIOS OPERACIONAIS
  {
    id:"u1",
    username:process.env.REACT_APP_SGV_U1_USERNAME||"av-pcc227",
    password:process.env.REACT_APP_SGV_U1_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_U1_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U1_PASSWORD, "av-pcc227").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_U1_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U1_PASSWORD, "av-pcc227").salt :
      "",
    passwordVersion:"2.0",
    role:"user",
    name:"3º Sgt Cortez",
    vehicleId:"v1"
  },
  {
    id:"u2",
    username:process.env.REACT_APP_SGV_U2_USERNAME||"av-met141",
    password:process.env.REACT_APP_SGV_U2_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_U2_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U2_PASSWORD, "av-met141").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_U2_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U2_PASSWORD, "av-met141").salt :
      "",
    passwordVersion:"2.0",
    role:"user",
    name:"3º Sgt Wendel",
    vehicleId:"v2"
  },
  {
    id:"u3",
    username:process.env.REACT_APP_SGV_U3_USERNAME||"av-ofve714",
    password:process.env.REACT_APP_SGV_U3_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_U3_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U3_PASSWORD, "av-ofve714").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_U3_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U3_PASSWORD, "av-ofve714").salt :
      "",
    passwordVersion:"2.0",
    role:"user",
    name:"3º Sgt Capetini",
    vehicleId:"v3"
  },
  {
    id:"u4",
    username:process.env.REACT_APP_SGV_U4_USERNAME||"av-lmu651",
    password:process.env.REACT_APP_SGV_U4_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_U4_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U4_PASSWORD, "av-lmu651").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_U4_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U4_PASSWORD, "av-lmu651").salt :
      "",
    passwordVersion:"2.0",
    role:"user",
    name:"3º Sgt Pedro Daniel",
    vehicleId:"v4"
  },
  {
    id:"u5",
    username:process.env.REACT_APP_SGV_U5_USERNAME||"av-lmu672",
    password:process.env.REACT_APP_SGV_U5_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_U5_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U5_PASSWORD, "av-lmu672").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_U5_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U5_PASSWORD, "av-lmu672").salt :
      "",
    passwordVersion:"2.0",
    role:"user",
    name:"3º Sgt Arruda",
    vehicleId:"v5"
  },
  {
    id:"u6",
    username:process.env.REACT_APP_SGV_U6_USERNAME||"av-lmu677",
    password:process.env.REACT_APP_SGV_U6_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_U6_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U6_PASSWORD, "av-lmu677").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_U6_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U6_PASSWORD, "av-lmu677").salt :
      "",
    passwordVersion:"2.0",
    role:"user",
    name:"3º Sgt Jadson",
    vehicleId:"v6"
  },
  {
    id:"u7",
    username:process.env.REACT_APP_SGV_U7_USERNAME||"av-lmu652",
    password:process.env.REACT_APP_SGV_U7_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_U7_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U7_PASSWORD, "av-lmu652").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_U7_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U7_PASSWORD, "av-lmu652").salt :
      "",
    passwordVersion:"2.0",
    role:"user",
    name:"3º Sgt Pedro Daniel",
    vehicleId:"v7"
  },
  {
    id:"u8",
    username:process.env.REACT_APP_SGV_U8_USERNAME||"av-lmu606",
    password:process.env.REACT_APP_SGV_U8_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_U8_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U8_PASSWORD, "av-lmu606").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_U8_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U8_PASSWORD, "av-lmu606").salt :
      "",
    passwordVersion:"2.0",
    role:"user",
    name:"3º Sgt V. Santos",
    vehicleId:"v8"
  },
  {
    id:"u9",
    username:process.env.REACT_APP_SGV_U9_USERNAME||"av-lmu605",
    password:process.env.REACT_APP_SGV_U9_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_U9_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U9_PASSWORD, "av-lmu605").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_U9_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U9_PASSWORD, "av-lmu605").salt :
      "",
    passwordVersion:"2.0",
    role:"user",
    name:"3º Sgt Arruda",
    vehicleId:"v9"
  },
  {
    id:"u10",
    username:process.env.REACT_APP_SGV_U10_USERNAME||"av-rmd696",
    password:process.env.REACT_APP_SGV_U10_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_U10_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U10_PASSWORD, "av-rmd696").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_U10_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U10_PASSWORD, "av-rmd696").salt :
      "",
    passwordVersion:"2.0",
    role:"user",
    name:"Cb Anjos",
    vehicleId:"v10"
  },
  {
    id:"u11",
    username:process.env.REACT_APP_SGV_U11_USERNAME||"av-rmd697",
    password:process.env.REACT_APP_SGV_U11_PASSWORD||"",
    passwordHash: process.env.REACT_APP_SGV_U11_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U11_PASSWORD, "av-rmd697").hash :
      "",
    passwordSalt: process.env.REACT_APP_SGV_U11_PASSWORD ?
      SecurePasswordHash.hashForStorage(process.env.REACT_APP_SGV_U11_PASSWORD, "av-rmd697").salt :
      "",
    passwordVersion:"2.0",
    role:"user",
    name:"Cb Diego",
    vehicleId:"v11"
  }
];

// Veículos (mantidos para compatibilidade - simplificados para evitar problemas de parsing)
export const INIT_VTR = [
  {id:"v1", code:"AV-PCC 227", responsible:"3º Sgt Cortez", status:"disponivel", userId:"u1", alteracoes:[]},
  {id:"v2", code:"AV-MET 141", responsible:"3º Sgt Wendel", status:"disponivel", userId:"u2", alteracoes:[]},
  {id:"v3", code:"AV-OFVE 714", responsible:"3º Sgt Capetini", status:"disponivel", userId:"u3", alteracoes:[]},
  {id:"v4", code:"AV-LMU 651", responsible:"3º Sgt Pedro Daniel", status:"disponivel", userId:"u4", alteracoes:[]},
  {id:"v5", code:"AV-LMU 672", responsible:"3º Sgt Arruda", status:"disponivel", userId:"u5", alteracoes:[]},
  {id:"v6", code:"AV-LMU 677", responsible:"3º Sgt Jadson", status:"disponivel", userId:"u6", alteracoes:[]},
  {id:"v7", code:"AV-LMU 652", responsible:"3º Sgt Pedro Daniel", status:"disponivel", userId:"u7", alteracoes:[]},
  {id:"v8", code:"AV-LMU 606", responsible:"3º Sgt V. Santos", status:"disponivel", userId:"u8", alteracoes:[]},
  {id:"v9", code:"AV-LMU 605", responsible:"3º Sgt Arruda", status:"disponivel", userId:"u9", alteracoes:[]},
  {id:"v10", code:"AV-RMD 696", responsible:"Cb Anjos", status:"disponivel", userId:"u10", alteracoes:[]},
  {id:"v11", code:"AV-RMD 697", responsible:"Cb Diego", status:"disponivel", userId:"u11", alteracoes:[]}
];

// Função para verificar configuração
export function checkEnvironmentConfig() {
  const securityInfo = EnvConfig.getSecurityInfo();

  if (!securityInfo.isConfigured) {
    return {
      usingDefaults: true,
      message: "Configure as variáveis de ambiente no arquivo .env",
      securityInfo
    };
  }

  return {
    usingDefaults: false,
    message: "Sistema configurado corretamente",
    securityInfo
  };
}

// Função para obter administradores ocultos
export function getHiddenAdmins() {
  return EnvConfig.isConfigured()
    ? EnvConfig.getAdminCredentials().filter(admin => admin.hidden)
    : [
        // 👥 ADMINISTRADORES OCULTOS (sem senhas hardcoded)
        {id:"teixeira", username:"teixeira", password:"", role:"admin", name:"Teixeira", vehicleId:null, hidden:true},
        {id:"caldas", username:"caldas", password:"", role:"admin", name:"Caldas", vehicleId:null, hidden:true}
      ];
}

// Função para obter administradores específicos por ID
export function getAdminById(adminId) {
  const admins = getHiddenAdmins();
  return admins.find(admin => admin.id === adminId);
}

// Função para obter mensagens de configuração
export function getConfigurationMessages() {
  const securityInfo = EnvConfig.getSecurityInfo();
  const configMessage = EnvConfig.getConfigMessage();

  return {
    security: {
      ...securityInfo,
      message: configMessage
    },
    users: {
      total: INIT_USERS.length,
      admins: INIT_USERS.filter(u => u.role === 'admin').length,
      regular: INIT_USERS.filter(u => u.role === 'user').length,
      usingEnv: securityInfo.isUsingEnvCredentials,
      message: securityInfo.usingEnv
        ? "Credenciais carregadas das variáveis de ambiente"
        : "Usando credenciais de desenvolvimento - configure .env"
    },
    vehicles: {
      total: INIT_VTR.length,
      message: `${INIT_VTR.length} veículos configurados`
    }
  };
}
